import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import {AvdbPricingAircraftBundle} from "./avdb-pricing-aircraft-bundle";
import {AvdbPricingDevice} from "./avdb-pricing-device";

export class AvdbPricingResponse extends JSONMapped() {
	@jsonProperty(JSONMapper.arrayOfClass(AvdbPricingAircraftBundle))
	aircraftBundles: Array<AvdbPricingAircraftBundle>;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbPricingDevice))
	devices: Array<AvdbPricingDevice>;

	params: Record<string, any>;

	constructor(data?: Partial<AvdbPricingResponse>) {
		super();
		Object.assign(this, data);
	}

	get hasBundles() {
		return this.aircraftBundles.length > 0 || this.devices.some(d => d.bundles.length > 0);
	}
}
